/**
 * Created by Mikhail Menshenin on 24.07.2026
 */

const LevelMasteryPrefabView = {
    createOnScene(levelMastery) {
        const scene = cleverapps.Scenes.GetRunningScene();
        const levelMasteryView = Prefab.instantiate(bundles.levelmastery.jsons.levelmastery_view_prefab_json, { logic: levelMastery });
        scene.levelMastery = levelMasteryView;

        const progressControl = new cc.Node();
        progressControl.addChild(levelMasteryView);
        scene.addChild(progressControl);

        ComponentMap.attach(progressControl, new HidingComponent({
            direction: HidingComponent.DIR.NONE,
            control: "levelmastery_progress"
        }));

        const controller = ComponentUtils.findComponentByName(levelMasteryView, "LevelMasteryViewController");
        cleverapps.UI.onPressed(progressControl, levelMasteryView.createListener(controller.onClick.bind(controller)));
    }
};
